module.exports = __webpack_public_path__ + "nunito-sans-latin-200italic.da7c09610c91ac990644a19f2d713357.woff";